<template>
  <div>
    <header-component />
    <div class="proDateMain">
      <div class="proDateOne">
        <div class="w1300">
          <!-- 面包屑 -->
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="item in product.breadcrumb"
              :key="item.name"
            >
              {{ item }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <!-- 面包屑 结束-->

          <div class="box flex-sbw">
            <div class="swiperBox">
              <div class="swiper-container swiper mySwiper1">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide slide"
                    v-for="(item, index) in productxq.xijietu || []"
                    :key="index"
                  >
                    <div class="imgBox flex-cc">
                      <!-- <img :src="item" :alt="item.ming" /> -->
                      <!-- 兼容两种格式：直接是链接 / 是对象（取tu/url） -->
                      <img
                        :src="
                          typeof item === 'string' ? item : item.tu || item.url
                        "
                        :alt="item.ming"
                      />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination pagtion"></div>
                <div class="swiper-button-prev swjt"></div>
                <div class="swiper-button-next swjt"></div>
              </div>

              <div class="thumb">
                <div thumbsSlider="" class="swiper-container swiper mySwiper2">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide slide"
                      v-for="(item, index) in productxq.xijietu || []"
                      :key="index"
                      @mouseenter="handleThumbHover(index)"
                      @mouseleave="handleThumbLeave"
                    >
                      <div class="imgBox flex-cc">
                        <!-- <img :src="item" :alt="item.ming" /> -->
                        <!-- 兼容两种格式：直接是链接 / 是对象（取tu/url） -->
                        <img
                          :src="
                            typeof item === 'string'
                              ? item
                              : item.tu || item.url
                          "
                          :alt="item.ming"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="title tit-32 fw700 cor-222">{{ productxq.ming }}</div>
              <div class="price mt-10">
                <span
                  class="nowPrice tit-24 cor-222"
                  v-if="productxq.jiage != 0"
                  >¥{{ productxq.jiage }}</span
                >
                <span class="noPrice tit-16" v-else @click="handleClick"
                  >联系购买 <i class="el-icon-mouse"></i>
                </span>
              </div>

              <div class="features mt-20">
                <div
                  class="item in-block"
                  v-for="(item, index) in productxq.shuxing.nengli"
                  :key="index"
                >
                  {{ item }}
                  <span v-if="index < productxq.shuxing.nengli.length"> </span>
                </div>
              </div>
			  <div class="features ">
				  <div
				  
					class="item in-block"
					v-for="(item, index) in productxq.shuxing.changjing"
					:key="index"
				  >
					{{ item }}
					<span v-if="index < productxq.shuxing.changjing.length"> </span>
				  </div>
			  </div>
              <div class="description">
                <div class="deliveryInfo">
                  <i class="icBox">
                    <svg
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      width="20"
                      height="20"
                    >
                      <path
                        d="M961.28 414.464v508.928c0 55.104-42.752 99.52-95.872 99.52H158.016c-52.928 0-95.872-44.48-95.872-99.392V100.224c0-54.784 43.072-99.392 95.552-99.392h406.016v348.544c0 35.904 28.16 65.088 62.528 65.088h335.04z m-17.472-64.96L626.176 19.008v330.368c0-0.064 0.128 0.128 0.064 0.128h317.568z m-723.52 64.96h208.128c17.28 0 31.232-14.592 31.232-32.512s-13.952-32.448-31.232-32.448H220.288c-17.216 0-31.168 14.528-31.168 32.448s13.952 32.512 31.168 32.512z m0 216.512h582.784c17.216 0 31.232-14.528 31.232-32.448 0-17.984-14.016-32.512-31.232-32.512H220.288c-17.216 0-31.168 14.528-31.168 32.512 0 17.92 13.952 32.448 31.168 32.448z"
                        fill="#000000"
                      ></path>
                    </svg>
                  </i>
				  <span v-for="(l,ii) in  productxq.deliveryInfo"><span v-if="ii!=0"> / </span>{{l}} </span>
                <!--  {{ product.deliveryInfo }}/ {{ product.invoiceInfo }}/
                  {{ product.guaranteeInfo }} -->
                </div>
                <div class="paymentMethods">
                  <i class="icBox">
                    <svg
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      id="mx_n_1748403499802"
                      width="20"
                      height="20"
                    >
                      <path
                        d="M938.88 256h-298.666667a256 256 0 0 0 0 512h298.666667v85.333333a42.666667 42.666667 0 0 1-42.666667 42.666667h-768a42.666667 42.666667 0 0 1-42.666666-42.666667V170.666667a42.666667 42.666667 0 0 1 42.666666-42.666667h768a42.666667 42.666667 0 0 1 42.666667 42.666667v85.333333z m-298.666667 85.333333h341.333334v341.333334h-341.333334a170.666667 170.666667 0 1 1 0-341.333334z m0 128v85.333334h128v-85.333334h-128z"
                        fill="#000000"
                      ></path>
                    </svg>
                  </i>
				  <!-- <span v-for="(l,ii) in  productxq.deliveryInfo"><span v-if="ii!=0"> / </span>{{l}} </span> -->
                  <span
                    v-for="(item, index) in productxq.paymentmethods"
                    :key="index"
                  >
                    {{ item }}
                    <span v-if="index < productxq.paymentmethods.length - 1">
                      、
                    </span>
                  </span>
                </div>
                <div class="shippingInfo">
                  <i class="icBox">
                    <svg
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      width="20"
                      height="20"
                    >
                      <path
                        d="M528.855 943.439V485.227l430.85-183.274v436.64l-430.85 204.846zM67.646 271.717L510.691 80.56l448.474 190.716L511.123 461.35 67.646 271.717zM497.15 943.439L64.83 738.593V301.954L497.15 485.228v458.21zM197.5 471.87l-0.953 61.157 166.644 77.59 0.956-61.17L197.5 471.87z"
                        fill="#000000"
                      ></path>
                    </svg>
                  </i>
                  {{
                    product.kuaidi > 0
                      ? product.kuaidixq
                      : "包邮（偏远地区除外）"
                  }}
                </div>
              </div>

              <div
                class="con-update-company"
                @click="updateCompany"
                v-if="$qu('renzhen') != 2"
              >
                <span class="link">
                  <span class="qi">企</span>支持对公转账 【点击绑定】
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>

              <div class="guige" v-if="productxq.kaiqiguige == 1">
                <div class="tit tit-18 fw700">选择版本</div>
                <div class="list">
                  <div
                    v-for="(g, i) in productxq.guige"
                    :key="g.id || i"
                    class="item"
                    :class="xgindex == i ? 'active' : ''"
                    @click="xuangui(i)"
                  >
                    <div class="imgBox flex-cc">
                      <img :src="g.tu[0]" />
                    </div>
                    <div class="con">
                      <div class="guige_tit tit-18">{{ g.ming }}</div>
                      <div class="guige_price mt-10">
                        <span class="guige_price" v-if="g.jiage != 0">
                          ¥{{ g.jiage }}
                        </span>
                        <span
                          class="guige_noPrice tit-16"
                          v-else
                          @click="handleClick"
                        >
                          联系购买
                          <i class="el-icon-mouse"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="buy flex-c">
                <div class="num">
                  <el-input-number
                    v-model="num"
                    @change="handleChange"
                    :min="1"
                    :max="99"
                  ></el-input-number>
                </div>
                <div class="btn flex-c">
                  <!-- <router-link
                    to=""
                    class="a addCart"
                    @click="addCart"
                  > -->
                  <div class="a addCart cur_pointer" @click="addCart(1)">
                    加入购物车
                  </div>
                  <!-- 加入购物车 -->
                  <!-- </router-link> -->
                  <!-- <router-link :to="{name: 'orderConfirm',params:{id:productxq.id,num:num,guigeid:guigeids}}" class="a buyNow">立即购买</router-link> -->
                  <div @click="handleClick" class="a buyNow"
                    >联系购买</div
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="proDateTwo">
        <div class="w1300">
          <div class="proDateTwox" v-html="productxq.xiangqing"></div>
        </div>
      </div>
    </div>

    <footer-component />

    <!-- 联系购买弹窗组件 -->
    <purchaseDialog
      v-if="showPurchaseDialog"
      @close="showPurchaseDialog = false"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
// 引用公用组件
let that;
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

// 引入购买弹窗组件
import purchaseDialog from "@/components/PurchaseDialog.vue";

// 引入swiper
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  name: "ProdetailIndex",

  components: {
    headerComponent,
    footerComponent,
    purchaseDialog,
  },

  data() {
    return {
      sid: 0,
      xgindex: -1,
      product: {
        id: "001", // 产品ID
        category: "产品专区", // 分类
        breadcrumb: ["产品专区"], // 面包屑导航
        name: "自适应智能夹爪 UniGripper", // 产品名称
        price: "2188.00", // 价格
        originalPrice: 2588.0, // 原价（如果有折扣）
        features: [
          // 产品特性
          "指尖键操作",
          "自适应抓取",
          "大行程，满足多场景需求",
        ],
        // deliveryInfo: "订单支付后48小时内发货", // 配送信息
		// deliveryInfo:[],
        invoiceInfo: "增票速开", // 发票信息
        guaranteeInfo: "正品保障", // 保障信息
        paymentMethods: ["支付宝支付", "微信支付"], // 支付方式
        shippingInfo: "包邮（偏远地区除外）", // 运费信息
        images: [
          // 产品图片
          {
            url: require("@/assets/navTwo-img.png"),
          },
          {
            url: require("@/assets/navTwo-img.png"),
          },
        ],
        specifications: [
          // 规格参数
          {
            name: "重量",
            value: "0.5kg",
          },
          {
            name: "材质",
            value: "航空铝合金",
          },
        ],

        peculiarity: [
          "欠驱自适应抓取",
          "刚性到柔软毫秒级精准控制",
          "指尖碰撞保护",
          "大行程，满足多场景需求组",
        ],

        relatedProducts: [
          // 相关产品
          {
            id: "002",
            name: "机械臂",
            price: 3580.0,
            image: "/images/products/arm/1.jpg",
          },
        ],
      },
      productxq: {
		  shuxing:{nengli:[],changjing:[]}
	  },
      num: 1,
      guigeids: 0,
      // 保存Swiper实例，方便后续更新
      productSwiper: null,
      thumbsSwiper: null, // 新增：保存缩略图Swiper实例
      // 新增：存储默认轮播图数据
      defaultXijietu: [],
      // 新增：鼠标悬停切换定时器
      hoverTimer: null,

      // 联系购买弹窗显示状态
      showPurchaseDialog: false,
    };
  },

  created() {
    // 获取路由参数中的产品ID
    this.sid = this.$route.params.id;
    // 异步请求产品详情数据
    this.CSH();

    //  this.initSwiper();
  },
  watch: {
    // 监听路由参数中的id变化
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId !== oldId) {
          // 更新sid为新的商品ID
          this.sid = newId;
          this.xgindex = -1;
          this.num = 1;
          this.guigeids = 0;
          // 重新获取新商品数据
          this.CSH();
        }
      },
      immediate: true, // 首次加载时也触发（可选，和created逻辑不冲突）
    },
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    // 异步请求产品详情数据（改回回调写法，适配原有$post）
    CSH() {
      const _this = this; // 保存当前实例上下文
      this.$post(
        "k=shangpin&c=xiangqing",
        { id: this.sid },
        function(s) {
          _this.productxq = s.shu;
          // 数据加载完成后更新Swiper
		  if(!_this.productxq.shuxing.nengli){
			  _this.productxq.shuxing.nengli=[]
		  }
		  if(!_this.productxq.shuxing.changjing){
			  _this.productxq.shuxing.changjing=[]
		  } 
          // 新增：保存默认轮播图数据
          _this.defaultXijietu = [...(_this.productxq.xijietu || [])];
          _this.updateSwiper();
        },
        function(err) {
          // 可选：添加错误回调
          console.error("产品详情请求失败：", err);
        },
      );
    },
    // 初始化Swiper
    initSwiper() {
      // 先销毁原有实例，避免重复
      if (this.productSwiper) {
        this.productSwiper.destroy(true, true);
      }
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy(true, true);
      }

      // 1. 初始化缩略图Swiper
      this.thumbsSwiper = new Swiper(".proDateOne .mySwiper2", {
        // loop: true,
        // modules: [Thumbs], // Swiper 6+必须注册模块
        spaceBetween: 10,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true, // 必须开启，用于缩略图选中状态
        observer: true,
        observeParents: true,
        //  loopedSlides: 5,
      });

      // 2. 初始化产品Swiper
      const swiper = this.thumbsSwiper;

      this.productSwiper = new Swiper(".proDateOne .mySwiper1", {
        slidesPerView: 1,
        spaceBetween: 0,
        // 修复分页器选择器多余空格
        // pagination: {
        //   el: ".swiper-pagination",
        //   type: "custom",
        //   renderCustom: function(swiper, current, total) {
        //     return (
        //       '<span class="customs">0' +
        //       current +
        //       "</span>" +
        //       '<span class="xian">/</span>' +
        //       '<span class="taoli">0' +
        //       total +
        //       "</span>"
        //     );
        //   },
        // },

        // 分页器
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 关键配置：监听元素变化自动更新
        observer: true,
        observeParents: true,
        // 懒加载（可选，优化图片加载）
        lazy: true,
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        //  loop: true,
        // loopAdditionalSlides: 5,
      });
    },

    // 更新Swiper（数据加载完成后调用）
    updateSwiper() {
      if (this.productSwiper) {
        // 强制更新Swiper布局
        this.productSwiper.update();
        // 重置Swiper到第一页（可选）
        this.productSwiper.slideTo(0);
      } else {
        // 如果还未初始化，重新初始化
        this.initSwiper();
      }
    },

    // 缩略图鼠标经过处理
    handleThumbHover(index) {
      // 清除之前的定时器
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }

      // 设置延迟切换，避免鼠标快速划过时频繁切换
      this.hoverTimer = setTimeout(() => {
        if (this.productSwiper) {
          // 切换到对应的图片
          this.productSwiper.slideTo(index, 300); // 300ms动画过渡
        }
      }, 150); // 150ms延迟，避免误触
    },

    // 缩略图鼠标离开处理
    handleThumbLeave() {
      // 清除定时器，防止切换执行
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
    },

    updateCompany() {
		if (this.$qu("yonghux")["id"]) {
			  this.$router.push("/companyAuth");
		}else{
			this.$router.push("/login");
		}
    },

    // 购买逻辑
    // mai() {
    //   if (!this.$qu("yonghux")["id"]) {
    //     this.$message.error("请先登录");
    //     return;
    //   }
    //   if (this.productxq.kaiqiguige == 1 && this.guigeids == 0) {
    //     this.$xiaoxi("请先选择规格");
    //     return false;
    //   }
    //   this.$router.push({
    //     name: "orderConfirm",
    //     params: {
    //       id: this.productxq.id,
    //       num: this.num,
    //       guigeid: this.guigeids,
    //     },
    //   });
    // },

    // 选择规格（核心修复：支持取消选择+恢复默认图片）
    xuangui(e) {
      // 新增：如果点击的是已选中的规格，取消选择
      if (this.xgindex === e) {
        // 取消选择规格
        this.xgindex = -1;
        this.guigeids = 0;
        // 恢复默认价格
        this.productxq.jiage =
          this.productxq.defaultJiage || this.productxq.jiage;
        // 恢复默认轮播图
        this.productxq.xijietu = [...this.defaultXijietu];
        // 更新Swiper
        this.updateSwiper();
        return;
      }

      // 正常选择规格逻辑
      this.xgindex = e;
      // 兼容老版本语法的空值判断
      const guigeList = this.productxq && this.productxq.guige;
      const selectedSpec = (guigeList && guigeList[e]) || {};

      // 新增：备份默认价格（用于取消选择时恢复）
      if (!this.productxq.defaultJiage) {
        this.productxq.defaultJiage = this.productxq.jiage;
      }
      // 更新价格
      this.productxq.jiage = selectedSpec.jiage || this.productxq.defaultJiage;

      // 核心修复：处理图片切换逻辑
      if (selectedSpec.tu) {
        // 如果规格有专属图片，使用规格图片
        // 兼容单图和多图：如果tu是数组直接用，否则包装成数组
        // this.productxq.xijietu = Array.isArray(selectedSpec.tu)
        //   ? [...selectedSpec.tu]
        //   : [selectedSpec.tu];
        this.productxq.xijietu = [...selectedSpec.tu];
      } else {
        // 规格无专属图片，使用默认图片
        this.productxq.xijietu = [...this.defaultXijietu];
      }

      // 更新规格ID
      this.guigeids = selectedSpec.id || 0;

      // 规格切换后更新Swiper
      this.updateSwiper();
    },

    // 加入购物车/立即购买

    addCart(goumai) {
      // 统一登录判断逻辑（Web端使用Vue Router跳转登录）
      const userInfo = this.$qu("yonghux") || {};
      if (!userInfo.kouling || !this.$qu("hyid")) {
        this.$alert("请先登录才能加入购物车", "", {
          confirmButtonText: "登录",
          confirmButtonClass: "Loginanniu",
          distinguishCancelAndClose: true,
          center: true,
          roundButton: true,
          callback: (action) => {
            if (action === "confirm") {
              // Web端跳转登录页，替换小程序的uni.navigateTo
              this.$router.push("/login");
            }
          },
        });
        return;
      }

      // 规格判断
      if (this.productxq.kaiqiguige == 1 && !this.guigeids) {
        this.$xiaoxi("请先选择规格");
        return false;
      }

      // 库存判断
      if (!(this.productxq.kucun > 0)) {
        this.$xiaoxi("库存不足");
        return false;
      }

      // 拼接参数
      let canshu = `ids=${this.productxq.id}&shuliang=${this.num}&guigeid=${
        this.guigeids
      }`;
      if (this.productxq.peisongfangshi) {
        canshu += `&peisongfangshi=${this.productxq.peisongfangshi}`;
      }

      const _this = this;
      // 加入购物车逻辑（改回回调写法）
      if (goumai === 1) {
        this.$post(
          `m=limitao&k=gouwuche&c=tianjia&${canshu}`,
          {},
          function(s) {
            // _this.$xiaoxi(s.shu);
            _this.$message({
              type: "success",
              message: "加入购物车成功！",
            });
          },
          function(err) {
            console.error("加入购物车失败：", err);
            _this.$xiaoxi("加入购物车失败，请重试");
          },
        );
      }
    },

    handleChange(value) {
      console.log(value);
    },

    handleClick() {
      this.showPurchaseDialog = true;
    },
    // 提交表单后的处理逻辑
    handleSubmit(formData) {
      var that = this;
      console.log("提交的表单数据：", formData);
      // 这里可以调用接口提交数据

      // 示例：this.$post('接口地址', formData).then(res => { ... })

      that.$post(
        "k=help&c=hezuo",
        formData,
        function(s) {
          if (s.shi == 1) {
            that.$message.success("提交成功，我们会尽快与您联系！");
          } else {
            that.$message.error(s.shu);
          }
        },
        function(err) {
          this.$message.error("提交失败，请重试");
        },
      );

      this.showPurchaseDialog = false;
    },
  },
};
</script>
<style lang="less">
.proDateTwox video {
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  // display: block !important;
}
.proDateTwox .edui-faked-video {
  width: 100% !important;
  height: auto !important;
}
</style>
<style lang="less" scoped>

.proDateMain {
  .proDateOne {
    background: #f9f9f9;
    padding: 0.3rem 0 0.8rem;
    .box {
      margin-top: 0.3rem;
      align-items: flex-start;
    }
    .swiperBox {
      width: 45%;
      position: sticky;
      top: 80px;

      .swiper {
        background: #fff;
        // height: 100%;
        // height: 4.85rem;
        // max-height: 5rem;
        .slide {
          height: auto;
          // padding: 0.2rem;
          .imgBox {
            height: 100%;
            height: 5rem;
            img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }
          }
        }

        // 分页器
        /deep/ .pagtion {
          bottom: 0.3rem;
          transform: translateY(-50%);
          transition: 0.5s;
          span {
            margin: 0 3px;
          }
          span.swiper-pagination-bullet-active {
            background: #000;
          }
        }

        // 前进后退箭头
        /deep/ .swjt {
          width: 0.4rem;
          height: 0.4rem;
          min-width: 30px;
          min-height: 30px;
          background: #e3e3e3;
          border-radius: 50%;
          transform: translateX(150%);
          transition: 0.5s;
          &:after {
            color: #fff;
            font-size: 12px;
          }

          &:hover {
            background: #bdbdbd;
          }

          &.swiper-button-prev {
            transform: translateX(-150%);
          }
        }
      }
      .thumb {
        position: absolute;
        bottom: 0.3rem;
        margin-top: 0.1rem;
        height: auto;
        width: 100%;
        transform: scale(0);
        transition: 0.5s;
        z-index: 1;
        .mySwiper2 {
          // height: 1rem;
          background: none;
          .swiper-wrapper {
            justify-content: center;
          }

          .slide {
            cursor: pointer;
            background: rgba(0, 0, 0, 0.2);
            border-radius: 5px;
            overflow: hidden;
            // border: 1px solid #eeeeee;
            width: 0.5rem;
            height: 0.5rem;

            .imgBox {
              height: 100%;
              &::after {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.2);
                transition: 0.5s;
              }
              img {
                max-height: 100%;
              }
            }

            &.swiper-slide-thumb-active {
              // border: 1px solid #000000;
              .imgBox {
                &::after {
                  opacity: 0;
                }
              }
            }
          }
        }
      }

      &:hover {
        .thumb {
          transform: scale(1);
          opacity: 1;
        }

        .swiper {
          .pagtion {
            opacity: 0;
            transform: translateY(-50%) scale(1.5);
          }

          .swjt {
            transform: translateX(0);
            &.swiper-button-prev {
              transform: translateX(0);
            }
          }
        }
      }
    }
    .info {
      margin-top: 0.3rem;
      width: 50%;

      .price {
        .noPrice {
          cursor: pointer;
          background-image: linear-gradient(-14deg, #001ff5 0%, #41b9e0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .features .item {
        color: #4c4c4c;
		min-width: 105px;
        span {
          display: inline-block;
          margin: 0.15rem 0.1rem;
        }
      }

      .description {
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        margin-top: 0.2rem;
        padding-top: 0.2rem;

        > div {
          margin: 0.15rem 0;
          display: flex;
          align-items: center;
          color: #3e3e3e;
          font-size: var(--font15);
        }

        .icBox {
          width: 18px;
          display: inline-flex;
          margin-right: 0.17rem;
          svg {
            max-width: 100%;
          }
        }
      }

      .con-update-company {
        background: #ebf5fa;
        border-radius: 1rem;
        color: #3da1cd;
        display: inline-block;
        margin: 0.1rem 0;
        padding: 6px 14px;
        cursor: pointer;
        font-size: var(--font14);
        .qi {
          align-items: center;
          background: #3da1cd;
          border-radius: 2px;
          color: #fff;
          display: inline-flex;
          font-size: var(--font12);
          height: 18px;
          justify-content: center;
          margin-right: 5px;
          width: 18px;
        }
      }

      .guige {
        margin-top: 0.2rem;

        .list {
          .item {
            margin-top: 0.1rem;
            cursor: pointer;
            padding: 0.1rem 0.2rem;
            border: 1px solid #ddd;
            border-radius: 0.06rem;
            position: relative;
            display: flex;
            align-items: center;
            gap: 0.2rem;

            &.active {
              border: 1px solid #000000;
            }

            .imgBox {
              width: 1rem;
              height: 1rem;

              img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
              }
            }

            .con {
              flex: 1;
              .guige_noPrice {
                cursor: pointer;
                background-image: linear-gradient(
                  -14deg,
                  #001ff5 0%,
                  #41b9e0 100%
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }
        }
      }

      .counselor-img {
        background: #eee;
        padding: 0.2rem;
        padding-bottom: 0.1rem;
        margin-top: 0.2rem;
        display: inline-block;
        text-align: center;

        .counselor-qrcode {
          max-width: 2rem;
          img {
            max-width: 100%;
          }
        }

        .counselor-desc {
          display: block;
          margin-top: 0.1rem;
        }
      }
    }

    .buy {
      margin-top: 0.5rem;
      gap: 0.3rem;

      .btn {
        .a {
          // width: 50%;
          padding: 0.1rem 0.3rem;
          font-size: var(--font15);
          border-radius: 100px;
          text-align: center;
          &.addCart {
            border: 1px solid #000000;
            color: #333;
            margin-right: 0.1rem;
          }
          &.buyNow {
            cursor: pointer;
            background: linear-gradient(-14deg, #001ff5 0%, #41b9e0 100%);
            color: #fff;
          }
        }
      }
    }
  }

  /deep/ .proDateTwo {
    padding: 1rem 0;

    .w1300 {
      width: 900px;
    }

    img {
      max-width: 100%;
    }

    /deep/ video {
      width: 100%;
      height: auto !important;
      object-fit: contain;
	  width: 100%;
    }

    .box {
      .le {
        width: 30%;
      }
      .cen {
        width: 30%;
        text-align: center;
      }
      .re {
        width: 30%;
      }
      .text > div {
        margin: 0.1rem 0;
        color: #555555;
        font-size: var(--font18);
      }
    }
  }
}

// 计数器样式
/deep/ .el-input-number {
  width: 110px;
  line-height: 28px;
  .el-input__inner {
    height: 30px;
    padding-left: 35px;
    padding-right: 35px;
    background: none;
    border: 0;
    line-height: 30px;
    font-size: var(--font20);
    color: #040404;
  }

  .el-input-number__decrease,
  .el-input-number__increase {
    width: 30px;
    border-radius: 50%;
    background: none;
    border: 1px solid rgba(154, 154, 154, 0.5);

    &:hover {
      color: #41b9e0;
      border-color: #41b9e0;
    }
  }
}

@media screen and (max-width: 767px) {
  .proDateMain {
    .proDateOne {
      .swiperBox {
        width: 100%;
        position: relative;
        top: 0;

        .swiper .swjt {
          transform: none;

          &.swiper-button-prev {
            transform: none;
          }
        }

        .thumb {
          opacity: 1;
          transform: scale(1);
        }
      }

      .info {
        width: 100%;
      }
    }

    .proDateTwo {
      padding: 0.3rem 0;
    }
  }
}
</style>
